import React from 'react';
import { useSelector } from 'react-redux';

import Table from 'components/Table';

import {
  getAnovaConfidenceInterval,
  getTableData,
  getTableStat
} from 'store/scenes/inferentialStatistics/selectors';

const getTableHeadersForSummary = confidenceInterval => ['Factor', 'n', 'Mean', 'Standard Deviation', `${confidenceInterval}% Confidence Interval`];

const getTableHeadersForAnalysis =
  ['Source', 'df', 'Sum of Squares', 'Mean Squares', 'F-Statistic', 'P-Value'];

export const SummaryDataTab = () => {
  const tableData = useSelector(state => getTableData(state));
  const tableDataStat = useSelector(state => getTableStat(state));
  const anovaConfidenceInterval = useSelector(state => getAnovaConfidenceInterval(state));

  return (
    <div className="content-item">
      <table className="infStatMarkup-table">
        <tbody>
          <tr>
            <td>
              Null Hypothesis
            </td>
            <td>
              <span className="font-900 font-16 mb-10 mr-5">H<sub>0</sub>: All group means are equal</span>
            </td>
          </tr>
          <tr>
            <td>
              Alternative Hypothesis
            </td>
            <td>
              <span className="font-900 font-16 mb-10 mr-5">H<sub>1</sub>: Not all group means are equal</span>
            </td>
          </tr>
        </tbody>
      </table>
      <h3>Summary Statistics by Factor</h3>
      <Table tableHeaders={getTableHeadersForSummary(anovaConfidenceInterval)} tableData={tableDataStat} />

      <h3>Analysis of Variance Table</h3>
      <Table tableHeaders={getTableHeadersForAnalysis} tableData={tableData} />
      <p className="mt-15">
        <i>Treatments</i> may also be referred to as <i>Between Groups</i>. <i>Error</i> may also be referred to as <i>Within Groups</i>.
      </p>
    </div>
  );
};
